module.exports = __webpack_public_path__ + "img/hero.275211dc.jpg";